"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayStyles = exports.getContentStyles = exports.getButtonContentStyles = exports.Title = exports.StyledText = exports.HeaderWrapper = exports.CloseButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getContentStyles = exports.getContentStyles = function getContentStyles(isMobile) {
  return {
    border: 1,
    borderRadius: 4,
    boxShadow: ['0 24px 38px rgba(0, 0, 0, 0.14)', '0 9px 46px rgba(0, 0, 0, 0.12)', '0 11px 15px rgba(0, 0, 0, 0.2)'].join(),
    display: 'flex',
    flexDirection: 'column',
    transform: isMobile ? 'translate(-47%)' : 'translate(-50%)',
    overflow: 'auto',
    width: isMobile ? '79%' : '90%',
    maxWidth: '560px',
    inset: isMobile ? '20% 48% 40px' : '40% 50% 40px',
    marginBottom: 'auto',
    position: 'absolute',
    maxHeight: '185px'
  };
};
var getOverlayStyles = exports.getOverlayStyles = function getOverlayStyles() {
  return {
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    zIndex: '1000'
  };
};
var getButtonContentStyles = exports.getButtonContentStyles = function getButtonContentStyles() {
  return {
    width: '496px',
    marginLeft: '12px'
  };
};
var Title = exports.Title = _styledComponents["default"].div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-17ha4s1-0"
})(["font-size:", ";line-height:26.4px;color:", ";margin-bottom:", ";margin-left:", ";margin-top:", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '20px' : '22px';
}, _palette.commonPalette.txBlack, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '4%' : '5px';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '0' : '12px';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '0' : '4px';
});
var StyledText = exports.StyledText = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-17ha4s1-1"
})(["font-size:14px;line-height:20px;color:", ";margin-bottom:", ";margin-left:", ";"], _palette.commonPalette.txBlack, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '5%' : '28px';
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? '0' : '12px';
});
var CloseButton = exports.CloseButton = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'close'
}).withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-17ha4s1-2"
})(["height:", ";color:", ";margin-top:4px;"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '18px' : '22px';
}, _palette.commonPalette.txBlack);
var HeaderWrapper = exports.HeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderWrapper",
  componentId: "sc-17ha4s1-3"
})(["display:flex;justify-content:space-between;padding:0;margin:", ";"], function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile ? '0' : '0 0 20px 0';
});
//# sourceMappingURL=styles.js.map